import React, { createContext, useContext, useState } from 'react';

// Traductions
const translations = {
  fr: {
    // Header
    nav: {
      project: "Le Projet",
      apartments: "Appartements",
      plans: "Plans",
      video: "Vidéo",
      vefa: "VEFA",
      contact: "Contact"
    },
    
    // Hero
    hero: {
      location: "Sacré-Cœur, Dakar",
      title: "RÉSIDENCE RYAD",
      subtitle: "Vivez le haut standing à Sacré-Cœur",
      description: "avec cuisines équipées et salle de sport",
      timeline: "Travaux : Avril 2026 • Livraison : 18 mois",
      cta: {
        reserve: "Réservez en VEFA",
        catalog: "Catalogue PDF"
      }
    },

    // Project
    project: {
      title: "Le Projet",
      subtitle: "Un immeuble R+5 haut standing avec cuisines équipées au cœur de Sacré-Cœur",
      features: {
        r5: "R+5",
        r5_desc: "Architecture moderne",
        cuisine: "Cuisine", 
        cuisine_desc: "Entièrement équipée",
        gym: "Salle de sport",
        gym_desc: "Équipements modernes",
        penthouse: "Penthouse",
        penthouse_desc: "Vue panoramique"
      },
      planning: "Planning",
      timeline: {
        start: "Avril 2026",
        start_desc: "Démarrage",
        end: "Sept 2027", 
        end_desc: "Livraison"
      },
      location_btn: "Voir l'emplacement"
    },

    // Apartments
    apartments: {
      title: "Les Appartements",
      subtitle: "Du studio au penthouse, trouvez l'espace qui vous correspond",
      types: {
        f2: {
          title: "F2",
          subtitle: "Idéal couples",
          features: ["2 pièces modernes", "Cuisine équipée", "Balcon privé"]
        },
        f3: {
          title: "F3", 
          subtitle: "Confort familial",
          features: ["3 pièces spacieuses", "2 chambres", "Terrasse"]
        },
        f4: {
          title: "F4",
          subtitle: "Espace & élégance", 
          features: ["4 pièces premium", "3 chambres + suite", "Double balcon"]
        },
        penthouse: {
          title: "Penthouse",
          subtitle: "Luxe exclusif",
          features: ["5+ pièces d'exception", "Terrasse panoramique", "Vue 360°"]
        }
      },
      cta: {
        info: "Demander infos",
        catalog: "Catalogue"
      }
    },

    // Video
    video: {
      title: "Découvrez l'appartement F4",
      subtitle: "Plongez dans l'univers de la Résidence RYAD avec notre présentation vidéo exclusive",
      tour_title: "Visite guidée de votre futur appartement",
      features: [
        "Découvrez les finitions haut de gamme",
        "Explorez l'aménagement des espaces", 
        "Visualisez la qualité des matériaux",
        "Imaginez-vous dans votre futur logement"
      ],
      highlights: "Points forts du F4",
      specs: {
        surface: "Surface :",
        surface_value: "4 pièces premium",
        bedrooms: "Chambres :",
        bedrooms_value: "3 dont suite parentale",
        view: "Vue :",
        view_value: "Balcons avec vue", 
        standing: "Standing :",
        standing_value: "Finitions luxueuses"
      },
      cta: {
        title: "Intéressé par cet appartement ?",
        subtitle: "Contactez-nous pour une visite personnalisée ou plus d'informations",
        whatsapp: "Discuter du F4 sur WhatsApp",
        catalog_title: "Documentation complète",
        catalog_desc: "Téléchargez notre catalogue PDF pour découvrir tous les types d'appartements disponibles à la Résidence RYAD",
        catalog_btn: "Catalogue PDF complet"
      },
      stats: {
        apartment: "Appartement",
        bedrooms: "Chambres", 
        floors: "Étages"
      }
    },

    // VEFA
    vefa: {
      title: "VEFA - Achat sécurisé",
      subtitle: "Vente en l'État Futur d'Achèvement • Paiements échelonnés sur 18 mois",
      timeline_title: "Planning de paiement sur 18 mois",
      steps: {
        reservation: {
          title: "Réservation",
          desc: "Acompte de réservation\nSécurise votre appartement"
        },
        construction: {
          title: "Construction", 
          desc: "Paiements mensuels\nPendant 18 mois"
        },
        delivery: {
          title: "Livraison",
          desc: "Solde final\nRemise des clés"
        }
      },
      why_title: "Pourquoi la VEFA ?",
      advantages: [
        { title: "Prix préférentiels", desc: "Tarifs avantageux" },
        { title: "Garantie décennale", desc: "Protection 10 ans" },
        { title: "Paiement échelonné", desc: "Sur 18 mois" },
        { title: "Valorisation", desc: "Investissement sûr" }
      ],
      financing: {
        title: "Financement bancaire facilité",
        subtitle: "Accompagnement personnalisé avec nos partenaires bancaires",
        features: ["Dossier simplifié", "Réponse rapide", "Accompagnement complet"],
        cta: "Discuter financement"
      }
    },

    // Contact
    contact: {
      title: "Contact",
      subtitle: "Réservez votre appartement dès aujourd'hui",
      form: {
        title: "Formulaire de contact",
        name: "Nom",
        email: "Email", 
        phone: "Téléphone",
        apartment_type: "Type d'appartement",
        message: "Message",
        message_placeholder: "Vos questions ou demandes spécifiques...",
        send: "Envoyer",
        whatsapp: "WhatsApp",
        success: "Merci ! Votre demande a été enregistrée et envoyée à SOGI SUARL."
      },
      company: "SOGI SUARL",
      contacts: {
        whatsapp_france: "WhatsApp France",
        whatsapp_senegal: "WhatsApp Sénégal", 
        email: "Email",
        phone: "Fixe"
      },
      location_btn: "Localisation Sacré-Cœur",
      company_info: {
        title: "Plus de 15 ans d'expérience",
        desc: "Promoteur immobilier reconnu spécialisé dans le haut standing au Sénégal",
        stats: {
          clients: "Clients satisfaits",
          warranty: "Garantie décennale"
        }
      },
      hours: {
        title: "Horaires",
        weekdays: "Lundi - Vendredi",
        saturday: "Samedi", 
        sunday: "Dimanche",
        closed: "Fermé"
      },
      footer: "© 2025 SOGI SUARL - Résidence RYAD | Tous droits réservés"
    },

    // Floor Plans
    floorPlans: {
      title: "Plans des Appartements",
      subtitle: "Découvrez les plans détaillés de nos différents types d'appartements avec leurs surfaces et aménagements",
      viewDetails: "Voir les détails",
      types: {
        F2: {
          title: "Appartements F2",
          description: "1 chambre + 1 salon - Idéal pour couples ou investissement locatif"
        },
        F3: {
          title: "Appartements F3", 
          description: "2 chambres + 1 salon - Parfait pour petites familles"
        },
        F4: {
          title: "Appartements F4",
          description: "3 chambres + 1 salon - Spacieux pour familles nombreuses"
        }
      },
      modal: {
        features: "Caractéristiques détaillées",
        interested: "Intéressé par cet appartement ?",
        contact: "Nous contacter"
      },
      cta: {
        title: "Un plan vous intéresse ?",
        description: "Contactez-nous pour plus d'informations sur les appartements disponibles et les modalités de réservation.",
        contact: "Nous contacter"
      }
    },

    // Common
    common: {
      phone_principal: "+221 78 717 28 28",
      phone_france: "+221 78 717 28 28", 
      phone_senegal: "+221 78 717 28 28",
      phone_office: "+221 33 867 73 89",
      email: "gestion@sogi.sn"
    }
  },

  en: {
    // Header
    nav: {
      project: "The Project",
      apartments: "Apartments",
      plans: "Floor Plans",
      video: "Video", 
      vefa: "Off-Plan",
      contact: "Contact"
    },

    // Hero
    hero: {
      location: "Sacré-Cœur, Dakar",
      title: "RÉSIDENCE RYAD", 
      subtitle: "Experience luxury living in Sacré-Cœur",
      description: "with underground parking and fitness center",
      timeline: "Construction: September 2025 • Delivery: 18 months",
      cta: {
        reserve: "Reserve Off-Plan",
        catalog: "PDF Catalog"
      }
    },

    // Project
    project: {
      title: "The Project",
      subtitle: "A luxury R+5 building with underground parking in the heart of Sacré-Cœur",
      features: {
        r5: "R+5",
        r5_desc: "Modern architecture",
        parking: "Parking",
        parking_desc: "Secure underground", 
        gym: "Fitness center",
        gym_desc: "Modern equipment",
        penthouse: "Penthouse",
        penthouse_desc: "Panoramic view"
      },
      planning: "Schedule",
      timeline: {
        start: "March 2026",
        start_desc: "Start",
        end: "Sept 2027",
        end_desc: "Delivery"
      },
      location_btn: "View location"
    },

    // Apartments
    apartments: {
      title: "The Apartments", 
      subtitle: "From studio to penthouse, find the space that suits you",
      types: {
        f2: {
          title: "F2",
          subtitle: "Perfect for couples",
          features: ["2 modern rooms", "Equipped kitchen", "Private balcony"]
        },
        f3: {
          title: "F3",
          subtitle: "Family comfort",
          features: ["3 spacious rooms", "2 bedrooms", "Terrace"]
        },
        f4: {
          title: "F4", 
          subtitle: "Space & elegance",
          features: ["4 premium rooms", "3 bedrooms + suite", "Double balcony"]
        },
        penthouse: {
          title: "Penthouse",
          subtitle: "Exclusive luxury",
          features: ["5+ exceptional rooms", "Panoramic terrace", "360° view"]
        }
      },
      cta: {
        info: "Request info",
        catalog: "Catalog"
      }
    },

    // Video
    video: {
      title: "Discover the F4 apartment",
      subtitle: "Dive into the world of Résidence RYAD with our exclusive video presentation",
      tour_title: "Guided tour of your future apartment",
      features: [
        "Discover high-end finishes",
        "Explore space layout",
        "Visualize material quality", 
        "Imagine yourself in your future home"
      ],
      highlights: "F4 highlights",
      specs: {
        surface: "Surface:",
        surface_value: "4 premium rooms",
        bedrooms: "Bedrooms:",
        bedrooms_value: "3 including master suite",
        view: "View:",
        view_value: "Balconies with view",
        standing: "Standard:",
        standing_value: "Luxury finishes"
      },
      cta: {
        title: "Interested in this apartment?",
        subtitle: "Contact us for a personalized visit or more information",
        whatsapp: "Discuss F4 on WhatsApp",
        catalog_title: "Complete documentation",
        catalog_desc: "Download our PDF catalog to discover all apartment types available at Résidence RYAD",
        catalog_btn: "Complete PDF catalog"
      },
      stats: {
        apartment: "Apartment",
        bedrooms: "Bedrooms",
        floors: "Floors"
      }
    },

    // VEFA
    vefa: {
      title: "Off-Plan - Secure purchase",
      subtitle: "Sale in Future State of Completion • Payments spread over 18 months",
      timeline_title: "Payment schedule over 18 months",
      steps: {
        reservation: {
          title: "Reservation",
          desc: "Reservation deposit\nSecures your apartment"
        },
        construction: {
          title: "Construction",
          desc: "Monthly payments\nDuring 18 months"
        },
        delivery: {
          title: "Delivery", 
          desc: "Final balance\nKey handover"
        }
      },
      why_title: "Why Off-Plan?",
      advantages: [
        { title: "Preferential prices", desc: "Advantageous rates" },
        { title: "10-year warranty", desc: "10-year protection" },
        { title: "Staggered payment", desc: "Over 18 months" },
        { title: "Value appreciation", desc: "Safe investment" }
      ],
      financing: {
        title: "Facilitated bank financing", 
        subtitle: "Personalized support with our banking partners",
        features: ["Simplified file", "Quick response", "Complete support"],
        cta: "Discuss financing"
      }
    },

    // Contact
    contact: {
      title: "Contact",
      subtitle: "Reserve your apartment today",
      form: {
        title: "Contact form",
        name: "Name",
        email: "Email",
        phone: "Phone",
        apartment_type: "Apartment type",
        message: "Message",
        message_placeholder: "Your questions or specific requests...",
        send: "Send",
        whatsapp: "WhatsApp", 
        success: "Thank you! Your request has been registered and sent to SOGI SUARL."
      },
      company: "SOGI SUARL",
      contacts: {
        whatsapp_france: "WhatsApp France",
        whatsapp_senegal: "WhatsApp Senegal",
        email: "Email",
        phone: "Office"
      },
      location_btn: "Sacré-Cœur Location",
      company_info: {
        title: "Over 15 years of experience",
        desc: "Recognized real estate developer specialized in luxury properties in Senegal",
        stats: {
          clients: "Satisfied clients",
          warranty: "10-year warranty"
        }
      },
      hours: {
        title: "Hours",
        weekdays: "Monday - Friday",
        saturday: "Saturday",
        sunday: "Sunday", 
        closed: "Closed"
      },
      footer: "© 2025 SOGI SUARL - Résidence RYAD | All rights reserved"
    },

    // Floor Plans
    floorPlans: {
      title: "Apartment Floor Plans",
      subtitle: "Discover detailed plans of our different apartment types with their surfaces and layouts",
      viewDetails: "View details",
      types: {
        F2: {
          title: "F2 Apartments",
          description: "1 bedroom + 1 living room - Ideal for couples or rental investment"
        },
        F3: {
          title: "F3 Apartments",
          description: "2 bedrooms + 1 living room - Perfect for small families"
        },
        F4: {
          title: "F4 Apartments", 
          description: "3 bedrooms + 1 living room - Spacious for large families"
        }
      },
      modal: {
        features: "Detailed features",
        interested: "Interested in this apartment?",
        contact: "Contact us"
      },
      cta: {
        title: "Interested in a floor plan?",
        description: "Contact us for more information about available apartments and reservation terms.",
        contact: "Contact us"
      }
    },

    // Common
    common: {
      phone_principal: "+221 78 717 28 28",
      phone_france: "+221 78 717 28 28",
      phone_senegal: "+221 78 717 28 28", 
      phone_office: "+221 33 867 73 89",
      email: "gestion@sogi.sn"
    }
  }
};

// Context
const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language] = useState('fr');

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, t }}>
      {children}
    </LanguageContext.Provider>
  );
};